import { getStore as getSharedFavoritesStore } from 'owa-favorites';
export default function getFavoritePersona(personaId, emailAddress) {
    return personaId
        ? getFavoritePersonaByPersonaId(personaId)
        : getFavoritePersonaByEmail(emailAddress);
}
function getFavoritePersonaByPersonaId(personaId) {
    var personas = getSharedFavoritesStore()
        .favoritesPersonaNodes.values()
        .filter(function (node) { return node.personaId && node.personaId === personaId; });
    if (personas && personas.length > 0) {
        return personas[0];
    }
    return undefined;
}
function getFavoritePersonaByEmail(emailAddress) {
    var personas = getSharedFavoritesStore()
        .favoritesPersonaNodes.values()
        .filter(function (node) {
        return node.allEmailAddresses &&
            node.allEmailAddresses.some(function (email) { return emailAddress.toLocaleLowerCase() === email.toLocaleLowerCase(); });
    });
    if (personas && personas.length > 0) {
        return personas[0];
    }
    return undefined;
}
//# sourceMappingURL=getFavoritePersona.js.map